import React from 'react';
import {
  Form, Checkbox, Spin, Icon,
} from 'antd';
import {
  Box,
} from '../../shared/components';
import InlineCard from '../components/InlineCard';

export default function RrhhTab({
  rrhh, form, noConformidades, onChangeRrhhSeleccionados, rrhhSeleccionados,
}) {
  const { getFieldDecorator } = form;
  const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
  let content = '';
  const { listado, loading } = rrhh;
  const { seleccionada } = noConformidades;
  let { usuarios_implicados: rrhhArray } = seleccionada;
  rrhhArray = (typeof (rrhhArray) !== 'undefined') ? rrhhArray : [];

  if (!Array.isArray(rrhhArray)) {
    rrhhArray = rrhhArray.split(',');
  }

  for (let i = 0; i < rrhhArray.length; i += 1) {
    if (rrhhArray[i] !== undefined) {
      rrhhArray[i] = parseInt(rrhhArray[i], 10);
    }
  }

  content = (
    <InlineCard
      headerText="RRHH CAUSANTES"
      content={(
        <Box px={5} py={3}>
          <Spin indicator={antIcon} spinning={loading} size="large">
            {listado.map(item => (
              <Form.Item key={item.id}>
                {getFieldDecorator(`rrhh[${item.id}]`, {
                  initialValue: (rrhhArray.indexOf(item.id) >= 0) || (rrhhSeleccionados.filter(valor => valor === item.id).length > 0),
                  valuePropName: 'checked',
                })(
                  <Checkbox idRrhh={item.id} onChange={e => onChangeRrhhSeleccionados(e)}>
                    {item.nombre}
                    {' '}
                    {item.apellidos}
                  </Checkbox>,
                )}


              </Form.Item>
            ))}
          </Spin>
        </Box>
      )}
    />
  );

  return content;
}
